export const dashHome = {
  index: {
    boxes: {
      reservas: "Buchungen",
      checkins: "Check-ins",
      ocupacion: "Auslastung",
      facturacion: "Umsatz",
      ingresosTotal: "Gesamtumsatz",
      saldos: "Offene Salden",
      solicitudes: "KI-Anfragen",
      facturas: "Offene Rechnungen",
      acciones: "Offene Aktionen",
      salen: "Heutige Abreisen",
      llegadas: "Nächste Anreisen",
      ingresosDesglose: "Umsatzaufschlüsselung",
    },
    editToolbar: {
      done: "Fertig",
      addBox: "Kachel hinzufügen",
      reset: "Zurücksetzen",
      hint: "Ziehen zum Verschieben · Ecke ziehen zum Skalieren",
      allBoxesVisible: "Alle Kacheln sind sichtbar.",
      removeTitle: "Entfernen",
      showOnboarding: "Einrichtungshinweis anzeigen",
    },
  },
  arrivals: {
    viewAll: "Alle Anreisen ansehen",
  },
  todayLeaving: {
    title: "Gäste mit Check-out heute",
    subtitle: "Für heute geplante Check-outs.",
    empty: "Heute reisen keine Gäste ab.",
    loading: "Heutige Check-outs werden geladen…",
    balance: "Saldo",
    balanceDueTitle: "Offener Betrag: {amount} {currency}",
    paid: "Bezahlt",
    paidTitle: "Buchung bezahlt",
    viewAll: "Alle Check-outs ansehen",
  },
  mobileNotice: {
    sheetAriaLabel: "WACheckin-App herunterladen",
    closeAriaLabel: "Schließen",
    title: "Holen Sie das Beste aus WACheckin heraus",
    desc: "Das Panel ist für <b>Desktop</b> ausgelegt. Auf dem Handy erhalten Sie eine Übersicht; um <b>alle Funktionen</b> bequem zu nutzen, öffnen Sie es am Computer oder laden Sie unsere <b>App</b> herunter.",
    appStorePrefix: "Laden im",
    googlePlayPrefix: "Jetzt bei",
    continueOnMobile: "Weiter auf dem Handy ansehen",
  },
};
